import logo from './logo.svg';
import './App.css';
import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import CreateSurvey from './components/Survey/create';
import CreateStepOneSurvey from './components/Survey/createStepOne';
function App() {
  return (
    <Router basename={'/survey'}>
      <Routes>
        <Route exact path="/" element={<CreateSurvey />} />
        <Route exact path="/create/stepone" element={<CreateStepOneSurvey />} />
      </Routes>
    </Router>
  );
}

export default App;
